const NUMBERS_ONLY_REGEX = /[\d.]/;

export const numbersOnly = (
  event: React.KeyboardEvent<HTMLInputElement>
): void => {
  if (!NUMBERS_ONLY_REGEX.test(event.key)) {
    event.preventDefault();
  }
};
